import { fetchAndActivate, getValue } from 'firebase/remote-config'
import { remoteConfig } from './firebase'

import store from '@/state/store'

export async function initRemoteConfig() {
  const rc = await remoteConfig()

  if (rc) {
    rc.settings.minimumFetchIntervalMillis = 0
    await fetchAndActivate(rc)
    store.commit('config/setFeatureFlags', {
      /* Don't forget to remove the feature flag after enabled on production */
      vehicleType: getValue(rc, 'vehicle_type').asBoolean(),
      dmsCheck: getValue(rc, 'dms_check').asBoolean(),
      importDevice: getValue(rc, 'websms_import_device').asBoolean(),
      selectableVehicleType: getValue(rc, 'websms_selectable_vehicle_type').asBoolean(),
      hideAddDomainButton: getValue(rc, 'hide_add_domain_button').asBoolean(),
      syncToERP: getValue(rc, 'sync_to_erp').asBoolean(),
      logHistory: getValue(rc, 'log_history').asBoolean(),
    })
  }
}
